import { useBetween } from "use-between";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useLocation } from "react-router";

const useOrders = () => {
  const { locale } = useBetween(useSelector((state) => state.useSharedState));
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/Navbar/Orders/MyOrders")
      mainTabClick(".password-orders-tab");
    else if (location.pathname === "/Navbar/Orders/DoneOrders")
      mainTabClick(".location-orders-tab");

    // hide Hamburger

    const hamburgerThirdLevel = document.querySelector(
      ".hamburger-third-level"
    );
    const navMenuThirdLevel = document.querySelector(".main-navbar-orders");

    document.addEventListener("click", function (event) {
      var Clicked = hamburgerThirdLevel.contains(event.target);

      //If you click the hamburger do something

      //If NOT, do something else
      if (!Clicked) {
        hamburgerThirdLevel.classList.remove("active-third-level");
        navMenuThirdLevel.classList.remove("active-third-level");
      }
    });

    const LanguageResponsive = document.querySelector(".main-navbar-orders");
    if (locale === "AR" || locale === "OR") {
      LanguageResponsive.style.left = "180px";
    } else {
      LanguageResponsive.style.left = "35px";
    }
  }, [location.pathname, locale]);

  function mainTabClick(newClassName) {
    var newTab = document.querySelector(newClassName);

    Array.from(document.querySelectorAll(".main-tab")).forEach(function (val) {
      val.style.fontWeight = "normal";
    });
    newTab.style.fontWeight = "bold";

    const hamburgerThirdLevel = document.querySelector(
      ".hamburger-third-level"
    );
    const navMenuThirdLevel = document.querySelector(".main-navbar-orders");
    hamburgerThirdLevel.classList.remove("active-third-level");
    navMenuThirdLevel.classList.remove("active-third-level");
  }
  const clickHamburger = () => {
    const hamburgerThirdLevel = document.querySelector(
      ".hamburger-third-level"
    );
    const navMenuThirdLevel = document.querySelector(".main-navbar-orders");

    hamburgerThirdLevel.classList.toggle("active-third-level");
    navMenuThirdLevel.classList.toggle("active-third-level");
  };

  return {
    locale,
    mainTabClick,
    clickHamburger,
  };
};

export default useOrders;
